import { Injectable } from '@angular/core';
import {
  // ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  // RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private auth: AuthService, private router: Router) {}

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  canActivate() {
    return this.authenticate();
  }

  canActivateChild(
  // childRoute: ActivatedRouteSnapshot,
  // state: RouterStateSnapshot,
  ): boolean | UrlTree {
    return this.authenticate();
  }

  private authenticate(): boolean | UrlTree {
    return this.auth.check() ? true : this.router.parseUrl('/auth/login');
  }
}
